import * as apiServices from "../services/apiServices";
import request from "../services/requestService";
// import { LOGIN_ACTION } from "../constant";

export const userSignUp = (requestMethod = request, params) => {
  return requestMethod(apiServices.userSignUpParams(params))
    .then(response => {
      return response;
    })
    .catch(e => {
      console.log("SignUp Failed", e.message);
    });
};

export const verifySignUpOTP = (requestMethod = request, params) => {
  return requestMethod(apiServices.verifySignUpOTPParams(params))
    .then(response => {
      return response;
    })
    .catch(e => {
      console.log("SignUp OTP Failed", e.message);
    });
};

export const userInfoUpdate = (requestMethod = request, params) => {
  return requestMethod(apiServices.userInfoUpdateParams(params))
    .then(response => {
      return response;
    })
    .catch(e => {
      console.log("User info update Failed", e.message);
    });
};

export const sendSignUpOtp = (requestMethod = request, params) => {
  /*   return function(dispatch) {
    dispatch({
      type: LOGIN_ACTION.OTP_START
    });
    return requestMethod(apiServices.sendSignUpOtpParams(params))
      .then(payload => {
        dispatch({
          type: LOGIN_ACTION.OTP_SUCCESS,
          payload
        });
      })
      .catch(e => {
        dispatch({
          type: LOGIN_ACTION.OTP_FAILURE
        });
      });
  }; */
  return requestMethod(apiServices.sendSignUpOtpParams(params))
    .then(response => {
      return response;
    })
    .catch(e => {
      console.log("User info update Failed", e.message);
    });
};

export const isUserExist = (requestMethod = request, params) => {
  return requestMethod(apiServices.isUserExistParams(params))
    .then(response => {
      return response;
    })
    .catch(e => {
      console.log("Check User Exist Failed", e.message);
    });
};
